import React from 'react';
import LcIcon from '../LcIcon';
import "./index.css";

const MenuOptionsHelper: React.FC = () => {
    const options = ["Agrupar por", "Colunas", "Densidades"];

    return (
        <div className={"divOrderMenuOptions"}>
            <div style={{
                display: 'flex',
                flexDirection: 'column'
            }}>
                {
                    options.map(option => {
                        return (
                            <span className={"spanMenuOptions"}>
                                {option}
                                <div style={{
                                    position: 'relative',
                                    right: '-20px'
                                }}>
                                    <LcIcon icon={"ppi ppi-chevron-right"} size={"small"} />
                                </div>
                            </span>
                        )
                    })
                }

                <span className={"spanMenuOptions"}>Redefinir visualização </span>
                <hr style={{ backgroundColor: "lightgrey" }} />
                <span className={"spanMenuOptions"}>Marcar todos</span>
                <hr style={{ backgroundColor: "lightgrey" }} />
                <span className={"spanMenuOptions"}>Legenda</span>
                <span className={"spanMenuOptions"}>Exportar CSV</span>
            </div>
        </div>
    );
};

export default MenuOptionsHelper;